import { compare, multiSort } from '../../../../helpers/column-sort';
import type { ProductOrderItem } from '../data/product-order-item';

/** Majority-vote brand and "brand | description" name; size_ounces tiebreak. */
export function familyDisplay(items: ProductOrderItem[]): { brand: string; name: string } {
  if (items.length === 0) {
    return { brand: '', name: '' };
  }

  const brand = majorityWithTiebreak(items, (i) => i.product.brand);
  const description = majorityWithTiebreak(items, (i) => i.product.description);

  return { brand, name: `${brand} | ${description}` };
}

function majorityWithTiebreak(
  items: ProductOrderItem[],
  field: (i: ProductOrderItem) => string
): string {
  const counts = new Map<string, number>();
  const firstSeen = new Map<string, ProductOrderItem>();
  for (const item of items) {
    const v = field(item);
    counts.set(v, (counts.get(v) ?? 0) + 1);
    if (!firstSeen.has(v)) {
      firstSeen.set(v, item);
    }
  }

  const sizeOf = (value: string) => firstSeen.get(value)?.product.size_ounces ?? 0;
  const entries = [...counts.entries()].sort(
    multiSort<[string, number]>(
      (a, b) => compare(b[1], a[1]),
      (a, b) => compare(sizeOf(b[0]), sizeOf(a[0])),
      (a, b) => compare(a[0], b[0])
    )
  );

  return entries[0][0];
}
